'use client';

import * as AccordionPrimitive from '@radix-ui/react-accordion';
import cn from 'clsx';
import * as React from 'react';

import { Icon, IconProps } from '../icon/Icon';

/**
 * @note DesignSystem 으로 정립 전 임시로 사용되는 아코디언 컴포넌트 입니다.
 */

const DeprecatedAccordion = AccordionPrimitive.Root;

const DeprecatedAccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => <AccordionPrimitive.Item ref={ref} className={cn(className)} {...props} />);
DeprecatedAccordionItem.displayName = 'DeprecatedAccordionItem';

const DeprecatedAccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn('group flex flex-1 items-center justify-between text-left transition-all [&[data-state=open]>svg]:rotate-180', className)}
      {...props}
    >
      {children}
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
DeprecatedAccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const DeprecatedAccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className="overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}
  >
    <div className={cn(className)}>{children}</div>
  </AccordionPrimitive.Content>
));

DeprecatedAccordionContent.displayName = AccordionPrimitive.Content.displayName;

const DeprecatedAccordionButton = ({ className, ...props }: IconProps) => {
  return (
    <div className={cn('shrink-0 transition-transform group-[[data-state=open]]:rotate-180', className)}>
      <Icon {...props} />
    </div>
  );
};

export { DeprecatedAccordion, DeprecatedAccordionItem, DeprecatedAccordionTrigger, DeprecatedAccordionContent, DeprecatedAccordionButton };
